"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsBase = require("js-base64");
var jwt = {
  extractJwtBody: function extractJwtBody(jwtToken) {
    var parts = jwtToken.split('.');
    var decodedBody = _jsBase.Base64.decode(parts[1]);
    var values = JSON.parse(decodedBody);
    values.id = parseInt(values.id, 10);
    if (values.abteilungen) {
      values.abteilungen = JSON.parse(values.abteilungen);
    }
    return values;
  }
};
var _default = exports["default"] = jwt;